import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-gray mt-3" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-11" }
const _hoisted_5 = ["onUpdate:modelValue", "onInput", "onRemove"]
const _hoisted_6 = { class: "col-1 text-end align-content-end" }
const _hoisted_7 = ["onClick", "title"]
const _hoisted_8 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filledValues, (value, key) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": ($event: any) => ((_ctx.filledValues[key]) = $event),
                onInput: ($event: any) => (_ctx.input(key, $event.target.value)),
                onRemove: ($event: any) => (_ctx.removeText(key))
              }, null, 40, _hoisted_5), [
                [_vModelText, _ctx.filledValues[key]]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.removeText(key)),
                class: "btn btn-outline-secondary mt-auto",
                title: _ctx.$t('form.buttonRemove')
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "fas fa-times" }, null, -1)
              ]))], 8, _hoisted_7)
            ])
          ])
        ])
      ]))
    }), 256)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "btn btn-outline-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addValue()))
      }, " Přidat ")
    ])
  ]))
}